/** Recognize an owned-media reference without confusing its id with a document
 * identity. Canonical references stay canonical in drafts, submits and OCR. */
export function stepMediaIdFromUrl(url: unknown): string | undefined {
  return typeof url === 'string'
    ? /^\/api\/step-media\/([a-zA-Z0-9_-]+)\/file$/.exec(url)?.[1]
    : undefined;
}

/** Delete owned step media by id or canonical URL. The Hub owns the row and
 * bytes; missing media is idempotent, but transport and other errors propagate. */
export async function deleteStepMedia(mediaIdOrUrl: string): Promise<void> {
  const mediaId = mediaIdOrUrl.match(/\/api\/step-media\/([^/]+)\/file/)?.[1] ?? mediaIdOrUrl;
  const { auth } = await import('./api');
  const base = import.meta.env.VITE_API_BASE_URL ?? '';
  const res = await fetch(`${base}/api/v1/step-media/${mediaId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${auth.getToken()}` },
  });
  if (!res.ok && res.status !== 404) throw new Error(`media delete failed: ${res.status}`);
}